export { default } from './SvgIcon';
export { default as createSvgIcon } from './createSvgIcon';

export { default as svgIconClasses } from './svgIconClasses';
export * from './svgIconClasses';
